import { useState } from "react";
import { useTranslation } from "react-i18next";

const ButtonGenerate: React.FunctionComponent<{ OnGenerate: any }> = (props) => {

    const { t } = useTranslation();
    const [isGenerate, setIsGenerate] = useState<Boolean>(false);

    const Generate = () => {
        setIsGenerate(true)
        props.OnGenerate().then(() => {
            setIsGenerate(false);
        }).catch(() => {
            setIsGenerate(false);
        })
    }

    return (
        <button type="submit" className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 ${isGenerate ? "disabled" : ""}`} onClick={Generate}>
           {isGenerate ? "generating..." :  t("generateDescTitle.generate")}
        </button>
    )
}

export default ButtonGenerate;